<template>
  <div class="invoice-list-container" @scroll="onScroll">
    <div v-if="showFilter" class="invoice-search-box">
      <app-search-box :placeholder="$t('invoice.searchPlaceholder')" :value="searchText" @input="onChangeSearchText"
        @search="search" @clear="search" size="sm"></app-search-box>
      <!--      <b-form-select-->
      <!--        name="invoice-type"-->
      <!--        size="sm"-->
      <!--        :value="selectedType"-->
      <!--        :options="filterTypeOptions"-->
      <!--        @input="onChangeType"-->
      <!--        @change="search"-->
      <!--      />-->
      <div class="chk-all">
        <b-form-checkbox :checked="checkAll" @change="onCheckAllChanged">
          {{ $t('app.selectAll') }}
        </b-form-checkbox>
      </div>
    </div>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="showLoadMore" infinite-scroll-distance="10"
      class="invoice-list">
      <div v-if="loading" class="p-2 animated-element">
        <invoice-list-skeleton></invoice-list-skeleton>
      </div>
      <div v-show="!isEmptyObject(groupedInvoicesByDate) && !loading" v-for="(group, date) in groupedInvoicesByDate"
        :key="date">
        <div class="invoice-group-date">
          <b-form-checkbox :checked="isGroupSelected(date)" @change="(checked) => onCheckGroupChanged(date, checked)">
          </b-form-checkbox>
          <div class="line"></div>
          <p class="issued">{{ issuedDate(date) }}: {{ group.length }} {{ $t('invoice.invoices') }}</p>
          <div class="line"></div>
        </div>
        <div class="invoice-item-wrapper" v-for="(invoice, index) in group" :key="invoice.id">
          <!-- write a function and pass it down to invoice-item (e.g. getTagColor(color)), in getTagColor use appStatistics to get color  -->
          <invoice-item :invoice="invoice" :get-tag-color="getTagColor" :hide-icon="!allowMultiSelect"
            :error-invoices="errorInvoices" :hide-invoice-type="hideInvoiceType" :index="showIndex ? index + 1 : null"
            :is-active="activeInvoice && activeInvoice.id === invoice.id"
            :is-selected="allowMultiSelect ? selectedInvoices.has(invoice.id) > 0 : false" @on-change="onCheckedChange"
            @on-right-click="onRightClick" @on-click="onClick(invoice, index)" @on-db-click="onDbClick(invoice, index)">
          </invoice-item>
          <div class="actions" v-show="isReconciliation">
            <button :disabled="invoice.origin === '4'" class="btn btn-sm btn-primary"
              @click="(event) => onReconciliation(invoice, event)">
              <i class="fal fa-check"></i>
            </button>
          </div>
        </div>
      </div>
      <div v-show="isEmptyObject(groupedInvoicesByDate) && !loading">
        <div class="invoice-item-wrapper" v-for="(invoice, index) in invoices" :key="invoice.id">
          <invoice-item :invoice="invoice" :hide-icon="!allowMultiSelect" :error-invoices="errorInvoices"
            :hide-invoice-type="hideInvoiceType" :index="showIndex ? index + 1 : null"
            :is-active="activeInvoice && activeInvoice.id === invoice.id"
            :is-selected="allowMultiSelect ? selectedInvoices.has(invoice.id) > 0 : false" @on-change="onCheckedChange"
            @on-right-click="onRightClick" @on-click="onClick(invoice, index)" @on-db-click="onDbClick(invoice, index)">
          </invoice-item>
          <div class="actions" v-show="isReconciliation">
            <button :disabled="invoice.origin === '4'" class="btn btn-sm btn-primary"
              @click="(event) => onReconciliation(invoice, event)">
              <i class="fal fa-check"></i>
            </button>
          </div>
        </div>
      </div>
      <div v-if="loadMoreInvoiceLoading" class="loading-more">
        <i class="fad fa-spinner-third fa-spin"></i>
      </div>
      <actions-context-menu ref="invoiceContextMenu" />
    </div>
  </div>
</template>

<script>
import DateTimeUtils from '@/utils/datetime';
import { isEmptyObject } from '@/utils/helper';
import AppSearchBox from '@/components/app-search-box/';
import InvoiceItem from '@/portal-components/invoice/invoice-item';
import InvoiceListSkeleton from '@/portal-components/invoice/invoice-list-skeleton';
import ActionsContextMenu from '@/portal-components/invoice/actions-menu/actions-context-menu';
import { mapState } from 'vuex';
import { getTagsById } from '@/utils/tag';

const allTagsById = getTagsById();

export default {
  name: 'InvoiceList',
  components: {
    InvoiceItem,
    AppSearchBox,
    InvoiceListSkeleton,
    ActionsContextMenu,
  },
  props: {
    loading: Boolean,
    invoices: Array,
    paging: {},
    activeInvoice: {},
    errorInvoices: {},
    selectedInvoices: Set,
    checkAll: Boolean,
    allowMultiSelect: {
      type: Boolean,
      default: true,
    },
    hideInvoiceType: false,
    showFilter: {
      type: Boolean,
      default: true,
    },
    showIndex: {
      type: Boolean,
      default: false,
    },
    isReconciliation: {
      type: Boolean,
      default: false,
    },
    groupedInvoicesByDate: Object,
    isGroupSelected: {
      type: Function,
      default: () => false,
    },
    loadMoreInvoiceLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['appStatistics']),
    showLoadMore() {
      return !(this.paging && this.paging.total > (this.paging.page * this.paging.limit));
    },
    filterTypeOptions() {
      return [
        { value: 'ALL', text: `${this.$t('app.all')}` },
        { value: 'PAID', text: `${this.$t('invoice.paid')}` },
        { value: 'VERIFIED', text: `${this.$t('invoice.verified')}` },
        { value: 'NOT_VERIFIED', text: `${this.$t('invoice.unconfirmed')}` },
      ];
    },
  },
  created() {
    this.$bus.on('load-more-success', this.onLoadMoreSuccess);
    this.changeRouteQuery({ search_text: null, paid: null, origin: null });
  },
  beforeDestroy() {
    this.$bus.off('load-more-success', this.onLoadMoreSuccess);
  },
  data() {
    return {
      selectedType: 'ALL',
      searchText: '',
    };
  },
  methods: {
    isEmptyObject,
    issuedDate(strDate) {
      if (!strDate) return '';
      const date = DateTimeUtils.parseDate(strDate);
      return `${this.$t('app.month')} ${date.month() + 1}, ${date.year()}`;
    },
    onCheckAllChanged(checkAll) {
      this.$bus.emit('on-select-all-items', checkAll);
    },
    onLoadMoreSuccess() { },
    onChangeSearchText(text) {
      this.searchText = text;
    },
    changeRouteQuery(query) {
      const currentRoute = this.$route;
      const queryObj = {
        ...currentRoute.query,
        ...query,
      };
      Object.keys(queryObj).forEach(k => !queryObj[k] && delete queryObj[k]);
      this.$router.push({
        name: currentRoute.name,
        params: this.$route.params,
        query: queryObj,
      }).catch(() => { });
    },
    loadMore() {
      this.$emit('on-load-more', this.paging);
    },
    // onChangeType(type) {
    //   if (type === 'PAID') {
    //     this.changeRouteQuery({
    //       paid: true,
    //       invoiceType: 'ALL',
    //       origin: null,
    //     });
    //   }
    //   if (type === 'ALL') {
    //     this.changeRouteQuery({
    //       paid: null,
    //       origin: null,
    //       invoiceType: 'ALL',
    //     });
    //   }
    //   if (type === 'VERIFIED') {
    //     this.changeRouteQuery({
    //       paid: null,
    //       origin: [4],
    //       invoiceType: 'ALL',
    //     });
    //   }
    //   if (type === 'NOT_VERIFIED') {
    //     this.changeRouteQuery({
    //       paid: null,
    //       origin: [1, 3],
    //       invoiceType: 'ALL',
    //     });
    //   }
    // },
    search() {
      this.changeRouteQuery({ search_text: this.searchText });
    },
    onDbClick(invoice, $index) {
      this.$emit('on-db-click', invoice, $index);
    },
    onClick(invoice, $index) {
      this.$emit('on-click', invoice, $index);
      this.$bus.$emit('on-click-invoice', invoice, $index);
    },
    onRightClick($event, invoice) {
      if (invoice.kind_of) {
        this.$refs.invoiceContextMenu.showMenu($event, invoice);
      }
    },
    onCheckedChange(param) {
      this.$bus.emit('on-selected-item-changed', param);
    },
    onCheckGroupChanged(date, selected) {
      this.$bus.emit('on-select-group-items', { date, selected });
    },
    onReconciliation(invoice, $event) {
      this.$emit('on-reconciliation', invoice, $event);
    },
    onScroll() {
      this.$refs.invoiceContextMenu.hideContextMenu();
    },
    getTagColor(tag) {
      if (tag && tag.id) {
        const tagInfo = allTagsById[tag.id]
        if (tagInfo) return tagInfo.hex_color || '#CCC';
      }
      return '#CCC';
    }
  },
};
</script>

<style scoped>
.invoice-list.paging {
  height: 89%;
}

.chk-all {
  width: 100px;
  font-size: 14px;
  color: #005DCA;
}

.paging a {
  margin: 0 4px;
}
</style>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-list.vue